import {
  LunchMenuitem,
  lunchMenuitemsSchema,
} from "@mjolnerbacken/shared/types/lunch-menu-item";

import { getRequest } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getShoolLunches({
  year,
  week,
  city,
}: {
  year: number;
  week: number;
  city: string;
}): Promise<LunchMenuitem[]> {
  return await getRequest(
    `${API_BASE_URL}/school-lunch?year=${year}&week=${week}&city=${city}`,
    lunchMenuitemsSchema,
  );
}
